import { postEvent } from '@tma.js/sdk'
import { SpinPrizePublic } from '../types/api'
import { generateStoryImage } from './storyGenerator.tsx'

/**
 * Публикует изображение в Telegram Stories
 * Использует готовое изображение с бекенда (stories_icon_url)
 */
export const shareToTelegramStory = async (prize: SpinPrizePublic) => {
  try {
    const tg = (window as any).Telegram?.WebApp
    const imageUrl = prize.stories_icon_url
    const imageUrlPremium = prize.stories_icon_url_premium

    // Проверяем наличие URL изображения
    if (!imageUrl || !imageUrl.startsWith('https://')) {
      throw new Error('stories_icon_url недоступен или не является HTTPS URL')
    }

    // Проверяем, есть ли у пользователя Telegram Premium
    const hasTelegramPremium = tg?.initDataUnsafe?.user?.is_premium === true

    // Проверяем, доступен ли метод shareToStory
    if (typeof tg?.shareToStory === 'function') {
      // Если у пользователя есть Telegram Premium, добавляем widget_link
      // Если нет - отправляем только изображение с текстом
      if (hasTelegramPremium) {
        tg.shareToStory(imageUrlPremium, {
          widget_link: {
            url: 'https://t.me/pauline_cake_club',
            name: prize.stories_text,
          },
        })
      } else {
        // Для пользователей без Premium добавляем ссылку в конец текста
        tg.shareToStory(imageUrl, {
          text: `${prize.stories_text}\n\nhttps://t.me/pauline_cake_club`,
        })
      }
      return
    }

    // Fallback: если shareToStory недоступен, открываем Telegram
    try {
      postEvent('web_app_open_link', {
        url: 'https://t.me/share/url?url=' + encodeURIComponent(imageUrl),
      })
    } catch (e) {
      window.open(
        'https://t.me/share/url?url=' + encodeURIComponent(imageUrl),
        '_blank'
      )
    }

    return true
  } catch (error) {
    console.error('Ошибка при публикации в Telegram Stories:', error)
    throw error
  }
}

/**
 * Проверяет, доступна ли функция публикации в Stories
 */
export const isStoryShareAvailable = (): boolean => {
  return (
    typeof (window as any).Telegram?.WebApp !== 'undefined' ||
    typeof postEvent === 'function'
  )
}

/**
 * Скачивает изображение сторис локально
 * Используется как fallback, если публикация в Telegram недоступна
 */
export const downloadStoryImage = async (prize: SpinPrizePublic) => {
  try {
    const imageBlob = await generateStoryImage(prize)
    const imageUrl = URL.createObjectURL(imageBlob)

    const downloadLink = document.createElement('a')
    downloadLink.href = imageUrl
    downloadLink.download = 'secret-wheel-story.png'
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)

    setTimeout(() => URL.revokeObjectURL(imageUrl), 1000)

    return true
  } catch (error) {
    console.error('Ошибка при скачивании изображения:', error)
    throw error
  }
}
